import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { MeasurementHeader } from "./measurementsApi";

const adapter = createEntityAdapter<MeasurementHeader>({
    selectId: (header) => header.id,
})

export type MeasurementHeadersState = EntityState<MeasurementHeader>

const initialState: MeasurementHeadersState = adapter.getInitialState()

export const measurementHeadersSlice = createSlice({
    name: "measurementHeaders",
    initialState,
    reducers: {
        addMeasurementHeader: adapter.addOne,
        updateMeasurementHeader: adapter.updateOne,
        removeMeasurementHeader: adapter.removeOne,
    },
})

export const { addMeasurementHeader, updateMeasurementHeader, removeMeasurementHeader } = measurementHeadersSlice.actions

export const selectMeasurementHeaders = (state: RootState): MeasurementHeadersState => state.measurementHeaders

export const
    { selectAll: selectAllMeasurementHeaders
    , selectById: selectMeasurementHeaderById
    } = adapter.getSelectors<RootState>(selectMeasurementHeaders)

export default measurementHeadersSlice.reducer
